import { getPageProperties } from 'views/utils/shopAndRuntimeConfigUtils'

import { DEFAULT_VARIANT_NAME } from 'shared/consts/optimizely'

export const getExperiment = experimentName => {
  const { experiments = [] } = getPageProperties()
  const defaultExperiment = {
    name: experimentName,
    variant: DEFAULT_VARIANT_NAME,
    isEnabled: false,
    variables: {}
  }

  const experiment =
    experiments.find(({ name }) => name === experimentName) || defaultExperiment

  return { ...experiment }
}
